<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Employee Performance</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
	<div class="card card-primary card-outline">
		<div class="card-header">
			Add Performance Data
		</div>
		<div class="card-body overflow-auto">
			<form @submit.prevent="addRating">
				<div :class="['form-group', errors.eid ? 'has-error' : '']">
					<label>Employee</label> 
					<v-select v-model="form.eid" :options="users" label="name" :reduce="users => users.id" placeholder="Select Employee" @input="getName"></v-select>
					<span v-if="errors.eid" :class="['badge bg-danger']">Please choose an employee.</span>
				</div>
				<div :class="['form-group', errors.parameter ? 'has-error' : '']">
					<label>Parameter</label> 
					<v-select v-model="form.parameter" :options="params" label="name" :reduce="params => params.name" placeholder="Select Parameter"></v-select>
					<span v-if="errors.parameter" :class="['badge bg-danger']">Please choose a parameter.</span>
				</div>
				<div :class="['form-group', errors.score ? 'has-error' : '']">
					<label>Score</label> 
					<input type="number" class="form-control" placeholder="Enter score" v-model="form.score" min="0" max="10" step=".1">
					<span v-if="errors.score" :class="['badge bg-danger']">Please enter a valid name.</span>
				</div>
				<div :class="['form-group', errors.postive ? 'has-error' : '']">
					<label>Positive</label> 
					<input type="text" class="form-control" placeholder="Enter positive" v-model="form.positive">
					<span v-if="errors.positive" :class="['badge bg-danger']">Please enter a valid positive.</span>
				</div>
				<div :class="['form-group', errors.negative ? 'has-error' : '']">
					<label>Negative</label> 
					<input type="text" class="form-control" placeholder="Enter negative" v-model="form.negative">
					<span v-if="errors.negative" :class="['badge bg-danger']">Please enter a valid negative.</span>
				</div>
				<div class="form-group">
					<button type="submit" class="btn btn-primary">Submit</button>
				</div>
			</form>
    </div>
    <div class="card-footer">
    	
		</div>
	</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isServiceManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getEmployees();
        	this.getParams();
        },
        
        data(){
        	return {
        		users: [],
        		params: [],
        		form: new Form({
        			eid: '',
        			ename: '',
        			parameter: '',
        			positive: '',
        			negative: '',
        			score: ''
        		}),
        		errors: []
        	}
        },
        
        methods: {
        	getEmployees(){
        		axios.post("/api/getTechs")
        		.then(response => {
        			this.users = response.data;
        		})
        	},
        	
        	getParams(){
        		axios.post("/api/getAllEPP")
        		.then(response => {
        			this.params = response.data;
        		})
        	},
        	
        	getName(){
        		this.form.ename = this.users.find(c => c.id == this.form.eid).name;
        	},
        	
        	addRating(){
        		this.form.post("/api/addEP")
        		.then(response => {
        			if(response.data == 200){
        				toast.fire({
        					icon: 'success',
        					title: 'Grading Added'
        				});
        				this.errors = [];
        				this.form.reset();
        			}
        			else
        				toast.fire({
        					icon: 'error',
        					title: 'Failed'
        				});
        		})
        		.catch((errors) => {
        			console.log(errors);
        			toast.fire({
        				icon: 'error',
        				title: 'Failed'
        			});
        			this.errors = errors.response.data.errors;
        		})
        	}
        }
    }
</script>
